import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Lookup } from '@shared-features/models/Lookup.model';

@Component({
  selector: 'app-chip-list',
  templateUrl: './chip-list.component.html',
  styleUrls: ['./chip-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipListComponent{
  @Input() items: Lookup[] = [];
  @Input() enableCounter: boolean = false;
  @Output() itemsChange = new EventEmitter<Lookup[]>();

  removeItem(item: Lookup): void {
    const filteredItems = this.items.filter((i) => i.id !== item.id);
    this.itemsChange.emit(filteredItems);
  }
}

